"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import InputQuantity from "../commons/InputQuantity";
import { useState } from "react";
import DialogConfirmation from "./DialogConfirmation";
import { createOffer } from "../../firebase/offers";
import { useAtom } from "jotai";
import { userAtom } from "../../store";

export default function DialogOffer({
    open,
    onClose,
    card,
}) {
    const [quantity, setQuantity] = useState(1)
    const [offerValue, setOfferValue] = useState(card.price)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [userData, setUserData] = useAtom(userAtom)

    // userId, card, originalPrice, offerPrice
    const handleCreateOffer = async () => {
        await createOffer(userData.id, card, card.price * quantity, offerValue)
        onClose()
        setShowConfirmModal(true)
    }

    return (
        <>
            <DialogConfirmation
                message="Your offer has been submitted! Please check your offers to see if it has been accepted."
                open={showConfirmModal}
                onClose={() => setShowConfirmModal(false)}
                buttonText="Done"
                title="Offer Sent"
                iconSrc="/assets/icons/icon-check-circle.svg"
                type="confirm"
            />

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden border-[1px] border-gray bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in w-full max-w-[604px]"
                        >
                            <div>
                                <div className="w-full relative p-6">
                                    <div className="flex justify-between">
                                        <div className="flex">
                                            <img src="/assets/icons/icon-logo.svg" alt="logo" className="mr-2" />
                                            <span className="text-white uppercase text-base">Make Offer</span>
                                        </div>

                                        <button
                                            onClick={onClose}
                                            className="top-2 right-2 cursor-pointer z-[1]"
                                        >
                                            <img
                                                src="/assets/icons/icon-close.svg"
                                                alt="Close"
                                                className="invert cursor-pointer"
                                            />
                                        </button>
                                    </div>

                                    <hr className="border-gray mt-4 mb-4"></hr>

                                    <div className="flex">
                                        <img src={card.pictures[0]} className="w-[111px] h-[111px] mr-5 border-primary border-[1px]" alt="picture" />

                                        <div className="w-full">
                                            <div className="text-base font-bold uppercase text-white">
                                                {card.title}
                                            </div>

                                            <p className="line-clamp-2 mt-3 mb-2 text-sm text-[#ffffff80]">
                                                {card.description}
                                            </p>

                                            <span className="uppercase text-sm font-bold text-primary mb-3 block">
                                                {card.rarity} - 2006
                                            </span>

                                            <div className="flex justify-between">
                                                <InputQuantity onChange={(value) => { setQuantity(value) }} />

                                                <span className="text-white text-base uppercase">
                                                    $ {(card.price * quantity).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="border-gray mt-5 mb-6"></hr>

                                    <div className="bg-[#0d0d0d] border-[1px] border-gray p-5">
                                        <span className="text-[#8F8F8F] text-base uppercase font-bold">Offer Amount</span>

                                        <input
                                            defaultValue={card.price * quantity}
                                            type="number"
                                            value={offerValue}
                                            onChange={(e) => setOfferValue(parseFloat(e.currentTarget.value))}
                                            className="text-[42px] text-white font-bold bg-transparent"
                                        />

                                        <hr className="border-gray"></hr>
                                    </div>
                                </div>

                                <div className="bg-[#0d0d0d] py-5 px-6 mt-[40px]">
                                    <div className="flex justify-between">
                                        <span className="text-[#8F8F8F] text-base uppercase font-bold">Your Offer</span>

                                        <span className="text-white">$ {offerValue.toFixed(2)}</span>
                                    </div>

                                    <button className="mt-7 mr-2 w-full uppercase text-sm bg-primary px-8 py-3 text-white hover:bg-white hover:text-black transition-all" onClick={handleCreateOffer}>
                                        Make Offer
                                    </button>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
